import { Theme } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';

/**
 * Sets benefit status to Active, Waived, Terminated, Refused, No Coverage
 * @param {*} benefitData 
 * @param {*} benefitName 
 * @param {*} userMeta 
 * @returns 
 */
const determineBenefitStatus = (benefitData, benefitName, userMeta) => {
    if (userMeta.hasRefused) {
        // refused health benefits mark  all health benefits as Refused
        if (([ 'Health', 'Health-Dental' ].includes(userMeta.hasRefused))) {
            if (([ 'drugs', 'majorMedical', 'paramedicals', 'vision', 'outOfCountry' ].includes(benefitName))) {
                return {
                    status: 'Refused',
                    color: Theme.colors.red
                };
            }
        }

        // dental refused
        if (([ 'Dental', 'Health-Dental' ].includes(userMeta.hasRefused))) {
            if (benefitName === 'dental') {
                return {
                    status: 'Refused',
                    color: Theme.colors.red
                };
            }
        }

        // Dependent Life always refused if populated
        if (benefitName === 'dependentLife') {
            return {
                status: 'Refused',
                color: Theme.colors.red
            };
        }
    }

    if (userMeta.hasWaived && userMeta.waiveFor !== 'Dependents') {
        // Waived health benefits mark  all health benefits as Waived
        if (([ 'Health', 'Health-Dental' ].includes(userMeta.hasWaived))) {
            if (([ 'drugs', 'majorMedical', 'paramedicals', 'vision', 'outOfCountry' ].includes(benefitName))) {
                return {
                    status: 'Waived',
                    color: Theme.colors.orange
                };
            }
        }

        // dental refused
        if (([ 'Dental', 'Health-Dental' ].includes(userMeta.hasWaived))) {
            if (benefitName === 'dental') {
                return {
                    status: 'Waived',
                    color: Theme.colors.orange
                };
            }
        }
    }

    // Terminated Toggle
    if (userMeta.status === 9 || (!benefitData.benefitActive && benefitData.benefitActiveOverride)) {
        return {
            status: 'Terminated',
            color: Theme.colors.red
        };
    }

    // Not Eligible Toggle
    if (
        benefitData.benefitActive
            && !benefitData.isEligible
            && (benefitData.eligibilityTermDate === null || benefitData.benefitReinstatementDate <= dates.getStartOfDay())
    ) {
        return {
            status: 'Not Eligible',
            color: Theme.colors.orange
        };
    }

    // Active
    if (benefitData.benefitActive) {
        return {
            status: 'Active',
            color: Theme.colors.skyBlue
        };
    }
        
    // No Coverage default
    return {
        status: 'No Coverage',
        color: Theme.colors.mainTextGrey
    };
};

export default determineBenefitStatus;